<template>
    <b-container fluid class="turn-content" id="external_turns">
        <b-card>
        <b-row align-h='end' >
            <b-col cols='4'>
                <h3 class='text-right'>Visualizacion de Turnos {{counts}}</h3>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col :cols='cols' v-for='item in items' :key='item.id'>
                <b-card border-variant='primary'
                        header-border-variant='primary'
                        header-text-variant='primary'
                        align='center'>
                        <b-row align-h='center'>
                            <b-col cols='4'>
                                <b-img :src='item.img' fluid-grow class='imgperfil' style = 'height:80px;' />
                            </b-col>
                            <b-col>
                                <h1>{{ item.turn }}</h1>
                                <p class='text-uppercase'>{{ item.customer }}</p>
                            </b-col>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
const items = [
  {
    id: 1,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "41"
  },
  {
    id: 2,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "42"
  },
  {
    id: 3,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "43"
  },
  {
    id: 4,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "44"
  },
  {
    id: 5,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "45"
  },
  {
    id: 6,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "41"
  },
  {
    id: 7,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "42"
  },
  {
    id: 8,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "43"
  },
  {
    id: 9,
    img: "http://190.60.211.17/ssca/images/5773e4864306a.png",
    name: "Juan Camilo Camacho",
    turno: "44"
  }
];
export default {
  name: "turns_external",
  data() {
    return {
      items: items,
      counts: items.length,
      cols: 4,
      timer: null
    };
  },
  watch: {
    items: function() {
      this.counts = this.items.length;
      console.log(this.counts);
    }
  },
  mounted() {
    window.setInterval(this.getData, 10000);
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store
        .dispatch("papeleriaRequestsAllReady")
        .then(response => {
          this.items = this.$store.getters.cafeteriaRequestsExt.turns;
          this.items.forEach(element => {
            let mainPath = localStorage.getItem("urlApi");
            mainPath = mainPath.replace("/api", "");
            element.img = mainPath + element.url;
          });
          this.cols = this.items.length > 4 ? 4 : 6;
          this.pending = this.items.length;
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
<style>
#external_turns h1 {
  font-size: 5em;
  color: brown;
  font-weight: bold;
}
#external_turns p {
  font-size: 18px;
  color: #00649c;
  font-weight: bold;
}
.turn-content {
  font-family: Arial, Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/views/external/turns/papeleria.vue